import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AdminUsersDatagrid } from '../../components/DataGrid/AdminUsers/AdminUsersDatagrid';
import { AdminUsersService } from '../../api/services/adminUsersService';
import { setAdminUsers } from '../../store/Reducers/AdminUsersSlice';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';

export const AccountManagementPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await AdminUsersService.getAdminUsers();
        dispatch(setAdminUsers(res));
      } catch (e: any) {
        dispatch(
          showNotification({
            message: `Failed to load users. ${e?.response?.data?.message || e?.message || ''}`,
            severity: 'error',
          }),
        );
      }
    };
    load();
  }, []);

  return <AdminUsersDatagrid />;
};
